<template>
  <div class="edu-home">
    <div class="content flex">
      <div class="left">
        <div
          class="left-item"
          :class="{ active: tab == 2 }"
          @click="handleTab(2)"
        >
          我的待办
        </div>
        <div
          class="left-item"
          :class="{ active: tab == 1 }"
          @click="handleTab(1)"
        >
          我的提醒
        </div>
      </div>
      <div class="right">
        <div class="top-tabs">
          <div
            class="tabs-box"
            :class="{ active: state === '' }"
            @click="handleTabState('')"
          >
            全部
          </div>
          <div
            class="tabs-box"
            :class="{ active: state === 0 }"
            @click="handleTabState(0)"
          >
            {{ tab == 2 ? '待办' : '待阅' }} · {{ noreadCount }}
          </div>
        </div>
        <div class="bottom-box">
          <Button
            v-if="noreadCount > 0"
            type="primary"
            class="all-btn"
            @click="handleBtn('allRead')"
            >全部标记已读</Button
          >
          <div class="table">
            <Table
              ref="selection"
              border
              stripe
              :columns="columns"
              :data="data"
            >
              <template slot="msgContent" slot-scope="{ row }">
                <div class="flex" style="padding: 20px 0; align-items: center">
                  <Badge v-if="row.msgIcon" dot :count="row.state == 0 ? 1 : 0">
                    <!-- <img :src="row.msgIcon" style="width:32px;" /> -->
                    <img
                      v-if="row.state == 0"
                      src="~@/assets/img/message/pic_news_n.png"
                      alt=""
                      style="width: 30px"
                    />
                    <img
                      v-else
                      src="~@/assets/img/message/pic_news_y.png"
                      alt=""
                      style="width: 30px"
                    />
                  </Badge>

                  <span
                    style="margin-left: 12px; cursor: pointer"
                    :style="row.state == 0 ? 'color:#1C7FFE;' : 'color:#888;'"
                    >{{ row.msgContent }}</span
                  >
                </div>
              </template>
              <template slot="name" slot-scope="{ row }">
                <span
                  style="margin-right: 5px; color: #1c7ffe; cursor: pointer"
                  >{{ row.name }}</span
                >
              </template>
              <template slot="action" slot-scope="{ row, index }">
                <span
                  v-if="
                    tab == 2 &&
                    (row.typeId == 1089 || row.typeId == 1104) &&
                    portOrg == 1
                  "
                  class="ordinary-color-430"
                  @click="handleBtn('check', row, index)"
                  >查看</span
                >
                <span
                  v-if="row.state == 0"
                  class="ordinary-color-430"
                  @click="handleBtn('read', row, index)"
                  >设为已读</span
                >
                <span
                  class="red-color-430"
                  @click="handleBtn('delete', row, index)"
                  >删除</span
                >
              </template>
            </Table>
            <div class="paging">
              <Page
                :current="pageInfo.page"
                :total="pageInfo.count"
                :page-size="pageInfo.size"
                show-total
                show-elevator
                @on-change="onPageChange"
              ></Page>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageEduIndex',
  components: {},
  data() {
    return {
      portOrg: '', // 哪个端 0：运营 1：教育局 2：学校 3：服务
      flag: 2, // 1待阅2待办
      tab: 2, // 1 待办 2 提醒
      state: '', // ''请求全部 1 已读 0 未读
      pageInfo: {
        page: 1,
        count: 0,
        size: 10
      },
      noreadCount: 0, // 未读数量
      columns: [
        {
          title: '内容',
          slot: 'msgContent'
        },
        {
          title: '时间',
          key: 'createTime',
          width: 300
        },

        {
          title: '操作',
          slot: 'action',
          width: 180,
          align: 'center',
          fixed: 'right'
        }
      ],
      data: []
    };
  },
  created() {
    this.portOrg = localStorage.getItem('portOrg');
    this.getMsgList();
  },
  mounted() { },

  methods: {
    // 获取未读消息数量
    async getMsgCount() {
      const res = await this.$http.getMsgCount({
        flag: this.tab,
        sign: 'manager_msg',
        state: 0
      });
      if (res.status == 200) {
        this.noreadCount = parseInt(res.message);
      }
    },
    // 获取消息列表
    async getMsgList() {
      const res = await this.$http.getMsgList({
        flag: this.tab,
        pageNum: this.pageInfo.page,
        pageSize: this.pageInfo.size,
        tag: '',
        sign: 'manager_msg',
        state: this.state
      });
      if (res.status === 200) {
        res.message.list.forEach(item => {
          item.msgContent = '';
          item.msgIcon = '';
          try {
            item.msgContent = item.result ? JSON.parse(item.result).msg : '';
            // item.msgIcon = item.result ?  JSON.parse(item.result).icon : ''
            item.msgIcon = require('@/assets/img/msg_icon.png');
          } catch (err) {
            console.log(err);
          }
        });
        this.data = res.message.list;
        if (this.pageInfo.page == 1) {
          this.pageInfo.count = parseInt(res.message.total);
        }
        this.getMsgCount();
      }
    },
    // 删除
    async deletetMsg(msgCode, typeId) {
      const res = await this.$http.deletetMsg({
        msgCode,
        typeId
      });
      if (res.status == 200) {
        this.pageInfo.page = 1;
        this.$Message.success('删除成功');
        this.getMsgList();
      }
    },
    async setMsgRead(msgCode = '', typeId = '') {
      const res = await this.$http.setMsgRead({
        msgCode,
        typeId
      });
      if (res.status == 200) {
        this.$Message.success('设置成功');
        this.getMsgList();
        // this.getDyMsgCount();
      }
    },
    async setAllMsgRead() {
      const res = await this.$http.setAllMsgRead({
        flag: this.tab,
        tag: '',
        sign: 'manager_msg'
      });
      if (res.status == 200) {
        this.$Message.success('设置成功');
        this.getMsgList();
        // this.getDyMsgCount();
      }
    },
    // 切换全部还是未读未办
    handleTabState(state) {
      this.state = state;
      this.pageInfo.page = 1;
      this.getMsgList();
    },
    handleTab(v) {
      this.tab = v;
      this.pageInfo.page = 1;
      this.getMsgList();
    },
    onPageChange(v) {
      this.pageInfo.page = v;
      this.getMsgList();
    },

    handleBtn(type, row) {
      switch (type) {
        case 'delete':
          this.$Modal.confirm({
            title: '是否确认删除？',
            onOk: () => {
              this.deletetMsg(row.msgCode, row.typeId);
            },
            onCancel: () => { }
          });
          break;
        case 'read':
          this.setMsgRead(row.msgCode, row.typeId);
          break;
        case 'allRead':
          if (this.pageInfo.count == 0) {
            return null;
          }
          this.setAllMsgRead();
          break;
        case 'check':
          this.$router.push({
            name: 'eduCenter_message_list_pending',
            query: { id: row.auditId, orgId: row.orgId, typeId: row.typeId }
          });
          break;
      }
    },
    handleFlagChange(v) { }
  }
};
</script>

<style lang="scss" scoped>
.edu-home {
  height: 100%;
  // background: #fff;
  padding: 20px;
  .content {
    height: 100%;
    box-sizing: border-box;
    padding: 16px;
    background: #fff;
    border-radius: 6px;

    .left {
      width: 146px;
      // border-right: 1px solid #eee;
      margin-right: 20px;
      .left-item {
        height: 44px;
        line-height: 44px;
        cursor: pointer;
        box-sizing: border-box;
        border-right: 4px solid transparent;
        padding-left: 26px;
      }
      // ul {
      //   li {
      //     height: 44px;
      //     line-height: 44px;
      //     cursor: pointer;
      //     box-sizing: border-box;
      //     border-right: 4px solid transparent;
      //     padding-left: 26px;
      //   }
      // }
      .active {
        background: rgba(97, 73, 241, 0.1);
        color: #488ffa;
        border-right: 4px solid #488ffa;
        font-weight: 600;
      }
    }
    // .right {
    //   flex: 1;
    //   width: 80%;
    //   overflow: hidden;
    //   .table {
    //     .pic_box {
    //       position: relative;
    //     }
    //   }
    // }
    .right {
      width: calc(100% - 146px);
      height: 100%;
      overflow: hidden;
      position: relative;
      .top-tabs {
        height: 44px;
        display: flex;
        .tabs-box {
          width: 90px;
          height: 100%;
          box-sizing: border-box;
          border: 1px solid #eeeeee;
          margin-right: 4px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #aaaaaa;
          line-height: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #fff;
          position: relative;
          z-index: 1;
          border-radius: 4px 4px 0px 0px;
        }
        .active {
          z-index: 3;
          border: 1px solid #dddddd;
          border-bottom: 1px solid #fff;
          font-weight: 600;
          color: #444444;
        }
      }
      .bottom-box {
        position: relative;
        z-index: 2;
        border: 1px solid #dddddd;
        border-radius: 0px 4px 4px 4px;
        width: 100%;
        height: calc(100% - 44px);
        margin-top: -1px;
        background: #fff;
        box-sizing: border-box;
        padding: 20px;
        .all-btn {
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
